import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import Layout from "@/components/Layout";
import { toast } from "sonner";
import { formatApiErrorDetail } from "@/lib/api";

export default function Register() {
  const nav = useNavigate();
  const { register } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(form);
      toast.success("Account created");
      nav("/citizen", { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Layout>
      <div className="max-w-md mx-auto px-6 py-16">
        <div className="mb-8">
          <div className="overline text-slate-500 mb-2">Citizen registration</div>
          <h1 className="font-display font-bold text-3xl tracking-tight">Create your account</h1>
          <p className="text-slate-600 mt-2 text-sm">Track your complaints and get notified when they are resolved.</p>
        </div>
        <Card className="border border-border/70">
          <CardHeader>
            <CardTitle className="font-display">Register</CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={submit} className="space-y-4" data-testid="register-form">
              <div className="space-y-2">
                <Label>Full name</Label>
                <Input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="register-name-input" />
              </div>
              <div className="space-y-2">
                <Label>Email</Label>
                <Input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="register-email-input" />
              </div>
              <div className="space-y-2">
                <Label>Phone (optional)</Label>
                <Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="register-phone-input" />
              </div>
              <div className="space-y-2">
                <Label>Password</Label>
                <Input type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="register-password-input" />
              </div>
              <Button type="submit" className="w-full" disabled={busy} data-testid="register-submit-btn">
                {busy ? "Creating..." : "Create account"}
              </Button>
            </form>
            <div className="mt-6 text-sm text-center text-slate-600">
              Already have an account?{" "}
              <Link to="/login" className="text-slate-900 font-medium underline underline-offset-4" data-testid="register-login-link">Sign in</Link>
            </div>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}
